import {axiosPrivate} from "../axios-config/axiosPrivate";
import {imageRequestConfig, standardRequestConfig} from "../axios-config/requestConfig";
import {BACKEND} from "../config/backend";
import {
    deleteArtistLocation as deleteArtistLocationShared,
    insertArtistLocation as insertArtistLocationShared,
    updateArtistLocation as updateArtistLocationShared,
} from "./artistLocationApi";


export const getAllArtists = () => {
    return axiosPrivate.get(`${BACKEND}/api/v1/artists`, {
        ...standardRequestConfig
    })
}

export const getTerminslots = ({options}) => {
    return axiosPrivate.get(`${BACKEND}/api/v1/artists/terminslots`, {
        ...standardRequestConfig
        , params: options
    })
}

export const getCalendarTerminToasterData = ({terminId}) => {
    return axiosPrivate.get(`${BACKEND}/api/v1/artists/calendar/termintoaster/${terminId}`, {
        ...standardRequestConfig
    })
}

export const getCalendarTerminToasterimages = ({projektId}) => {
    return axiosPrivate.get(`${BACKEND}/api/v1/artists/calendar/termintoasterimages/${projektId}`, {
        ...imageRequestConfig
    })
}

export const updateTermin = ({artistId, termin}) => {
    return axiosPrivate.put(`${BACKEND}/api/v1/artists/${artistId}/termine`, termin, {
        ...standardRequestConfig
    })
}

export const updateTerminParticipant = ({artistId, terminParticipantChange}) => {
    return axiosPrivate.put(`${BACKEND}/api/v1/artists/${artistId}/termine/participant`, terminParticipantChange, {
        ...standardRequestConfig
    })
}

export const deleteCalendarTerminToaster = ({terminId}) => {
    return axiosPrivate.delete(`${BACKEND}/api/v1/artists/calendar/termintoaster/${terminId}`, {
        ...standardRequestConfig
    })
}

export const insertArtistLocation = ({artistLocation}) => {
    // Wrapper for saga callers around the shared location API.
    return insertArtistLocationShared({ artistLocation });
}

export const deleteArtistLocation = ({artistLocation}) => {
    // Wrapper for saga callers around the shared location API.
    return deleteArtistLocationShared({ artistLocation });
}

export const updateArtistLocation = ({artistLocation}) => {
    // Wrapper for saga callers around the shared location API.
    return updateArtistLocationShared({ artistLocation });
}

export const updateArtistWorkTime = ({artistWorkTime}) => {
    return axiosPrivate.put(`${BACKEND}/api/v1/artists/${artistWorkTime.ArtistID}/worktime`, artistWorkTime, {
        ...standardRequestConfig
    })
}

export const insertArtistWorkTime = ({artistWorkTime}) => {
    return axiosPrivate.post(`${BACKEND}/api/v1/artists/${artistWorkTime.ArtistID}/worktime`, artistWorkTime, {
        ...standardRequestConfig
    })
}

export const deleteArtistWorkTime = ({artistWorkTime}) => {
    return axiosPrivate.delete(`${BACKEND}/api/v1/artists/${artistWorkTime.ArtistID}/worktime/${artistWorkTime.ArtWorkTmID}`, {
        ...standardRequestConfig
    })
}

export const getArtistHolidays = ({artistIdList, start, end}) => {
    return axiosPrivate.get(`${BACKEND}/api/v1/artists/holidays`, {
        ...standardRequestConfig
        , params: {start, end, artistids: artistIdList.join(",")}
    })
}

export const updateArtist = ({artist}) => {
    return axiosPrivate.put(`${BACKEND}/api/v1/artists`, artist, {
        ...standardRequestConfig
    })
}

export const deactivateArtists = ({artistIdList}) => {
    return axiosPrivate.put(`${BACKEND}/api/v1/artists/deactivate`, {artistIdList}, {
        ...standardRequestConfig
    })
}

export const getArtistDetailData = ({artistId, segments}) => {
    return axiosPrivate.get(`${BACKEND}/api/v1/artists/${artistId}`, {
        ...standardRequestConfig
        , params: {segments: segments}
    })
}

export const copyArtist = ({artistId}) => {
    return axiosPrivate.post(`${BACKEND}/api/v1/artists/copy`, {artistId}, {
        ...standardRequestConfig
    })
}

export const deleteArtist = ({artistId}) => {
    return axiosPrivate.delete(`${BACKEND}/api/v1/artists/${artistId}`, {
        ...standardRequestConfig
    })
}

export const getArtistEvents = ({params}) => {
    return axiosPrivate.get(`${BACKEND}/api/v1/artists/events`, {
        ...standardRequestConfig,
        params
    })
}
